import { render } from "./LotsView.vue?vue&type=template&id=0a1e84b0&scoped=true&ts=true&lang=pug"
import script from "./LotsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotsView.vue?vue&type=script&lang=ts&setup=true"

import "./LotsView.vue?vue&type=style&index=0&id=0a1e84b0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1e84b0"]])

export default __exports__